import { fetch } from "./API";

export const FetchInstallmentRatesCFGroups = async () => {
  try {
    return await fetch(
      `${process.env.REACT_APP_API_URL}/installment-rates-cf-group/list`
    );
  } catch (err: any) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
